var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustryIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6316 14.421C30.5687 14.421 27.2632 17.7265 27.2632 21.7894C27.2632 23.7894 28.0696 25.6019 29.3684 26.9286V35.0696L34.6316 37.7011L39.8948 35.0696V26.9286C41.1937 25.6001 42 23.7894 42 21.7894C42 17.7265 38.6945 14.421 34.6316 14.421ZM34.6316 16.5263C37.5324 16.5263 39.8948 18.8862 39.8948 21.7894C39.8948 24.6927 37.5324 27.0526 34.6316 27.0526C31.7308 27.0526 29.3684 24.6927 29.3684 21.7894C29.3684 18.8862 31.7308 16.5263 34.6316 16.5263ZM34.6316 35.3497L31.4737 33.7708V28.4169C32.4356 28.8779 33.4967 29.158 34.6316 29.158C35.7665 29.158 36.8276 28.8779 37.7895 28.4169V33.7708L34.6316 35.3497Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36841 18.6316H22V20.7369H9.36841V18.6316Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36841 24.9474H22V27.0527H9.36841V24.9474Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36841 31.2632H22V33.3684H9.36841V31.2632Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 46H50.4211V6H2V46ZM4.10526 8.10526H48.3158V43.8947H4.10526V8.10526Z",
    fill: "#333333",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryIco);
export default __webpack_public_path__ + "static/media/industryIco.517e134c2162d3ff3982eed12411f494.svg";
export { ForwardRef as ReactComponent };